import moment from "moment-timezone";
import Tooltip from "@mui/material/Tooltip";

import currencyFormatter from "../../helpers/currencyFormatter";

const columns = [
  {
    name: "Sheet ID",
    selector: "sheetId",
    sortable: true,
    width: "105px",
  },
  {
    name: "Date",
    selector: "date",
    sortable: true,
    cell: (row) => {
      return row.date ? moment(row.date).format("M/D/YY") : "-";
    },
    width: "85px",
  },
  {
    name: "Peak",
    selector: "peak",
    sortable: true,
    width: "80px",
  },
  {
    name: "Departure Code",
    selector: "departCode",
    sortable: true,
    width: "125px",
  },
  {
    name: "Departure Display Name",
    selector: "departDisplayName",
    sortable: true,
    minWidth: "150px",
    maxWidth: "160px",
    cell: (row) => {
      return (
        <Tooltip
          classes={{
            tooltip: "multiline-tooltip",
          }}
          title={row.departDisplayName}
        >
          <div className="two-line-content">
            {row.departDisplayName}
          </div>
        </Tooltip>
      );
    },
  },
  {
    name: "Arrival Code",
    selector: "arriveCode",
    sortable: true,
    width: "125px",
  },
  {
    name: "Arrival Display Name",
    selector: "arriveDisplayName",
    sortable: true,
    minWidth: "150px",
    maxWidth: "160px",
    cell: (row) => {
      return (
        <Tooltip
          classes={{
            tooltip: "multiline-tooltip",
          }}
          title={row.arriveDisplayName}
        >
          <div className="two-line-content">
            {row.arriveDisplayName}
          </div>
        </Tooltip>
      );
    },
  },
  {
    name: "Aircraft",
    selector: "aircraftInternalType",
    sortable: true,
    minWidth: "120px",
    maxWidth: "140px",
    cell: (row) => {
      return (
        <Tooltip
          classes={{
            tooltip: "multiline-tooltip",
          }}
          title={row.aircraftInternalType}
        >
          <div className="two-line-content">
            {row.aircraftInternalType}
          </div>
        </Tooltip>
      );
    },
  },
  {
    name: "Seats",
    selector: "seats",
    sortable: true,
    width: "85px",
  },
  {
    name: "Price",
    selector: "price",
    sortable: true,
    minWidth: "120px",
    maxWidth: "140px",
    cell: (row) => {
      if (
        row?.price &&
        !isNaN(row?.price)
      ) {
        return currencyFormatter.format(row.price);
      }

      return "-";
    },
  },
  {
    name: "Price Strength",
    selector: "priceStrength",
    sortable: true,
    width: "120px",
  },
  {
    name: "CC Eligible",
    selector: "ccEligible",
    sortable: true,
    width: "105px",
    cell: (row) => {
      return row.ccEligible ? "Yes" : "No";
    },
  },
  {
    name: "CC Fee",
    selector: "ccFee",
    sortable: true,
    minWidth: "120px",
    maxWidth: "140px",
    cell: (row) => {
      if (
        row?.ccFee &&
        !isNaN(row?.ccFee)
      ) {
        return currencyFormatter.format(row.ccFee);
      }

      return "-";
    },
  },
  {
    name: "CC Price",
    selector: "ccPrice",
    sortable: true,
    minWidth: "120px",
    maxWidth: "140px",
    cell: (row) => {
      if (
        row?.ccPrice &&
        !isNaN(row?.ccPrice)
      ) {
        return currencyFormatter.format(row.ccPrice);
      }

      return "-";
    },
  },
  {
    name: "Expiration Date",
    selector: "expDateTime",
    sortable: true,
    cell: (row) => {
      return row.expDateTime ? moment(row.expDateTime).format("M/D/YY") : "-";
    },
    width: "125px",
  },
  {
    name: "Default Departure",
    selector: "defaultDeparture",
    sortable: true,
    width: "125px",
    cell: (row) => {
      return row.defaultDeparture ? "Yes" : "No";
    },
  },
];

export { columns };
